/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Format_Forbids_RankInputs */



/**
* | output |
* | --- |
* | "Only Standard and Limited events can be National or Continental championships" |
*
* @param {Err_Tournament_Format_Forbids_RankInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_format_forbids_rank = /** @type {((inputs?: Err_Tournament_Format_Forbids_RankInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Format_Forbids_RankInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seuls les événements Standard et Limited peuvent être des championnats nationaux ou continentaux")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo los eventos Standard y Limited pueden ser campeonatos nacionales o continentales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Apenas eventos Standard e Limited podem ser National Championship ou Continental Championship")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo gli eventi Standard e Limited possono essere campionati nazionali o continentali")
	return /** @type {LocalizedString} */ ("Only Standard and Limited events can be National or Continental championships")
});